import $ from 'jquery'
export default {
    name: 'modal-edit-groupe-visites-medicales',
    components: {},
    props: {
        groupe: Object
    },
    data() {
        return {
            search_word: null,
            search_word_examen: null,
            loading: false,
            grp: ''
        }
    },
    watch: {
        search_word() {
            this.searchAnalyse()
        },
        search_word_examen() {
            this.searchExamen()
        }
    },
    computed: {
        latestVisiteEnCours() {
            return this.$store.getters["latestVisiteMedicaleAnnuelle"]
        },

        categoriesAnalyses() {
            return this.$store.getters["categoriesAnalyses"];
        },

        examens() {
            return this.$store.getters["examens"];
        }

    },
    mounted() {

        var div_top_edit = $('.stickanal').offset().top;

        console.log(div_top_edit)
        $('#editGroupeVM .modal-body').on("scroll", function () {

            console.log('abalo')

            let div_top_edit = $('#editGroupeVM .searchbox-edit').offset().top;

            console.log(div_top_edit)

            if (div_top_edit < 0) {
                $("#editGroupeVM .show-on-fixed-create").fadeIn()
                $("#editGroupeVM .modal-body").addClass("pt-0")

            } else {
                $("#editGroupeVM .show-on-fixed-create").fadeOut()
                $("#editGroupeVM .modal-body").removeClass("pt-0")
            }


        })

    },
    methods: {

        searchAnalyse: function () {
            this.$store.dispatch('searchAnalyses', this.search_word)
        },
        searchExamen: function () {
            this.$store.dispatch('searchExamen', this.search_word_examen)
        },
        editGroupeVisiteMedicales: function () {
            this.loading = true
            let societe_id = null

            if (this.$route.params.id === undefined) {
                societe_id = 0
            } else {
                societe_id = this.$route.params.id
            }

            this.$store.dispatch('editGroupeParametrageVM', { id: societe_id, data: this.groupe }).then(
                () => {

                    this.loading = false

                    $('.modal').modal('hide')

                    if (Object.keys(this.latestVisiteEnCours).length !== 0 && societe_id !== 0) {
                        let data = { visite_medicale_id: this.latestVisiteEnCours.id }
                        this.$store.dispatch('initVisitesMedicalesProgrammation', { societe_id: societe_id, data: data }).then(
                            () => {
                                this.$store.dispatch('getProgrammationsVisitesMedicales', this.latestVisiteEnCours.id)
                                this.$store.dispatch('getSocieteVisiteMedicaleStats', this.latestVisiteEnCours.id)
                            }
                        )
                    }
                    this.successEditGroupeVM()
                }
            )
        },
        successEditGroupeVM: function () {
            this.$toasted.show('le groupe a été modifié avec succès', {
                duration: 3000,
                action: [{
                    text: 'X',
                    onClick: (e, toastObject) => {
                        toastObject.goAway(0);
                    }
                }],
                theme: 'toasted-primary',
                type: 'success',
                position: 'top-center'

            })
        },


    }
}


